import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SRC = `${API}/dsf-stage/`;

// Owner-only staging preview — shots charge the signed-in Betohalics wallet (sandbox DB on preview).
export default function DeepSeaFurtuneStage() {
    const { user, loading, refreshUser } = useAuth();
    const navigate = useNavigate();
    const [allowed, setAllowed] = useState(null);
    useEffect(() => {
        if (!user) return;
        axios.post(`${API}/dsf-stage-session`).then((r) => setAllowed(!!r.data?.allowed)).catch(() => setAllowed(false));
    }, [user]);
    const leave = () => { refreshUser?.(); navigate('/lobby'); };
    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;
    if (allowed === false) return <Navigate to="/lobby" replace />;
    if (allowed === null) return null;
    return (
        <div className="fixed inset-0 z-[60] bg-[#041c26]" data-testid="dsf-stage">
            <iframe
                src={SRC}
                title="Betohalics Deep Sea Furtune"
                allow="fullscreen; autoplay"
                allowFullScreen
                className="h-full w-full border-0"
                data-testid="dsf-stage-iframe"
            />
            <div className="absolute left-[112px] top-1 flex items-center gap-1 rounded-full bg-black/55 p-0.5 backdrop-blur"
                data-testid="dsf-stage-badge">
                <button type="button" onClick={leave}
                    className="flex items-center gap-0.5 rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-bold text-white/90 hover:bg-white/20"
                    data-testid="dsf-stage-back">
                    <ArrowLeft className="h-3 w-3" /> Back
                </button>
            </div>
        </div>
    );
}
